var map = {
	"./1.webp": 30131,
	"./2.webp": 95858,
	"./3.webp": 47197,
	"./3a31228f-10dd-463c-b358-4b6afc796442 copy.webp": 31176,
	"./4 copy.webp": 10693,
	"./4.webp": 18668,
	"./5.webp": 75887,
	"./6.webp": 16590,
	"./7.webp": 55689,
	"./8.webp": 31832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49006;